import { useMe } from "@/api/me";

export const useRole = () => {
  const { data: user, ...rest } = useMe();

  return { role: user?.role, ...rest };
};
